module.exports = __webpack_public_path__ + "static/media/lupa-blanca.15502c18.svg";